export function isSearchStoreInitial(searchState) {
    if (searchState.searchSegments[0]) {
        return searchState.searchSegments[0].from.length == 0 && searchState.searchSegments[0].to.length == 0;
    }
    return false;
}
export default function useReloadIfSearchStoreMissing(searchState) {
    if (process.env.BUILD_TARGET !== "client")
        return;
    if (isSearchStoreInitial(searchState)) {
        window.location.reload();
        return true;
    }
    return false;
}
